export default function SettingBoxWrapper({ BoxTitle = "", children, BoxLabel, addMarginTop = true, addPaddingTop = true, labelCustomClass = '' }) {
    return (
        <>
            <div className={`${addMarginTop ? 'mt-2' : ''} greyBox h-100 p-3 align-items-center`}>
                <div className='row d-flex align-items-center p-1'>
                    <span className='GridTitle pb-2'>{BoxTitle}</span>
                </div>
                <hr className='my-0' />
                <div className={`p-1 pe-0 mt-1 ${addPaddingTop ? 'pt-3' : ''} `}>
                    {BoxLabel &&
                        <label className={labelCustomClass}> {BoxLabel}</label>
                    }
                    {children}
                </div>
            </div>
        </>
    )
}